import React from "react";
import PropTypes from "prop-types";

import "../../components/pageHeader.scss";
import HeaderBgImg from "../../images/bg1.jpg";
import { motion } from "framer-motion";
import { ParallaxBanner } from "react-scroll-parallax";

const titleVariants = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -100 },
};

const CaseStudyPageHeader = ({ title }) => {
  return (
    <>
      <ParallaxBanner
        layers={[{ image: HeaderBgImg, speed: -20 }]}
        className="page-header blog_single_page-header"
      >
        <div className="max-w-container mx-auto px-4 pt-24">
          <div className="mx-auto flex justify-center lg:px-5 lg:-mx-4">
            <div className="w-full lg:w-10/12 px-6">
              <div className="text-left text-white">
                
                <motion.h1
                  variants={titleVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  transition={{ type: "spring", duration: 1 }}
                  className="font-medium"
                >
                  {title}
                </motion.h1>
                
              </div>
            </div>
          </div>
        </div>
        <div className="page_header_overlay"></div>
      </ParallaxBanner>
    </>
  );
};

CaseStudyPageHeader.propTypes = {
    title: PropTypes.string.isRequired,
    post: PropTypes.shape({
      publishedAt: PropTypes.string,
    }),
  };
  
export default CaseStudyPageHeader;
